if (!customElements.get('product-photo-gallery')) {
  customElements.define(
    'product-photo-gallery',
    class ProductPhotoGallery extends HTMLElement {
      connectedCallback() {
        this.syncGallery();
        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, () => {
          window.requestAnimationFrame(() => this.syncGallery());
        });
      }

      disconnectedCallback() {
        this.variantChangeUnsubscriber?.();
      }

      syncGallery() {
        const mediaItems = document.querySelectorAll(
          'media-gallery .product__media-list .product__media-item .product__modal-opener--image img'
        );

        if (!mediaItems.length) return;

        const galleryItems = Array.from(mediaItems).map((sourceImage) => {
          const item = document.createElement('figure');
          item.className = 'product-photo-gallery__item';
          item.setAttribute('role', 'listitem');

          const image = document.createElement('img');
          image.src = sourceImage.currentSrc || sourceImage.src;
          image.srcset = sourceImage.srcset;
          image.sizes = '(min-width: 750px) calc((min(100vw, var(--page-width)) - 3.2rem) / 3), calc(100vw - 3rem)';
          image.alt = sourceImage.alt;
          // This gallery sits below the main product content, so every duplicate
          // image can be deferred without delaying the primary product gallery.
          image.loading = 'lazy';
          image.decoding = 'async';

          item.append(image);
          return item;
        });

        this.replaceChildren(...galleryItems);
      }
    }
  );
}
